module.exports = __webpack_public_path__ + "static/media/PK.c519e9b1.svg";